/* VINOD — background video on the banner carousel's "Background image + text" slide.
   Loaded by sections/vinod-banner-carousel.liquid.

   Autoplay with sound is blocked by every browser until the visitor has interacted
   with the page, so the play attempt is made with the authored sound setting and, if
   the browser refuses, the video is muted and played again. The speaker button then
   lets the visitor turn sound on or off. Videos pause while off-screen. */

(function () {
  'use strict';

  function paint(btn, muted) {
    if (!btn) return;
    btn.setAttribute('aria-pressed', muted ? 'true' : 'false');
    btn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
  }

  function attempt(video, btn) {
    var played = video.play();
    if (played && typeof played.catch === 'function') {
      played.catch(function () {
        video.muted = true;
        paint(btn, true);
        var retry = video.play();
        if (retry && typeof retry.catch === 'function') retry.catch(function () {});
      });
    }
  }

  function init(video) {
    if (video.dataset.vdBcVideoReady === '1') return;
    video.dataset.vdBcVideoReady = '1';

    var card = video.closest('.vd-bc__slide');
    var btn = card ? card.querySelector('[data-vd-bc-sound]') : null;

    video.muted = video.dataset.sound !== 'true';
    paint(btn, video.muted);
    attempt(video, btn);

    if (btn) {
      btn.addEventListener('click', function (event) {
        /* the card is a link — never follow it from the speaker button */
        event.preventDefault();
        event.stopPropagation();
        video.muted = !video.muted;
        paint(btn, video.muted);
        if (!video.muted) attempt(video, btn);
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              attempt(video, btn);
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.2 }
      ).observe(video);
    }
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-vd-bc-video]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* theme editor re-renders the section */
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
})();
